import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import BreathworkUserDetail from '../../../BreathworkHub/BreathworkUserDetail';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyBreathworkUserDetail } from './companyBreathworkApi';

/**
 * Company Breathwork → one employee's/member's breathwork profile. Reuses the
 * shared detail page with the company-scoped fetcher (the backend 404s any
 * user who doesn't belong to this company).
 */
const CBreathworkUserDetail = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>User Breathwork Profile | Shoorah</title>
      </Helmet>
      <BreathworkUserDetail
        fetcher={fetchCompanyBreathworkUserDetail}
        backPath={`/${slug}/breathwork/users`}
        backLabel={isB2BFansMode ? 'Back to Members' : 'Back to Employees'}
      />
    </div>
  );
};

export default CBreathworkUserDetail;
